import validate from "/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.10.7_db0@0.3.4_eslint@9.29.0_jiti@2.4._5749465a6cc5ab138d03e186a5cef86d/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "authorisation-role-based": () => import("/app/apps/dashboard/src/middleware/authorisation-role-based.ts"),
  "block-parent-child-access": () => import("/app/apps/dashboard/src/middleware/block-parent-child-access.ts"),
  "check-add-material": () => import("/app/apps/dashboard/src/middleware/check-add-material.ts"),
  "load-child-details": () => import("/app/apps/dashboard/src/middleware/load-child-details.ts"),
  "redirect-dashboard": () => import("/app/apps/dashboard/src/middleware/redirect-dashboard.ts"),
  "start-teaching": () => import("/app/apps/dashboard/src/middleware/start-teaching.ts")
}